module.exports = __webpack_public_path__ + "scss/default.scss";